import React from "react";
import { ContextTc } from "..";
import { useContext } from "react";
import { Spinner } from "components/individual/Spinner/Spinner";
import LoadingText from "components/individual/TextLoading";
import ButtonV2 from "components/individual/ButtonsV2/Button";
import Icon from "components/individual/HeaderIcon";

export default function ExcelButton() {
  const hook = useContext(ContextTc);

  if (hook.tcs.length <= 0) return;

  if (hook.isDownloadingExcel)
    return (
      <Spinner hidden={false} text={<LoadingText>Descargando</LoadingText>} />
    );

  return (
    <ButtonV2 type="button" onClick={hook.downloadExcel}>
      <span>Excel</span>
      <Icon icon="excel" />
    </ButtonV2>
  );
}
